import React from 'react';

const ArrowHalfIcon = ({ color = '#fff', ...props }) => (
	<svg width="24" height="24" viewBox="0 0 24 24" {...props}>
		<g fill="none" fillRule="evenodd">
			<path d="M24 24V0H0v24z" />
			<path
				d="M12.42 1.96h-1.5c.15 3.17.17 6.33.25 9.5v7.52l-.13-.22a14.54 14.54 0 0 0-5.05-4.49l-.62 1.36A13.07 13.07 0 0 1 11.69 22 13.15 13.15 0 0 1 18 15.63l-.62-1.36a14.25 14.25 0 0 0-5.22 4.77c-.04-5.72.047-11.413.26-17.08z"
				fill={color}
				fillRule="nonzero"
			/>
		</g>
	</svg>
);

export default ArrowHalfIcon;
